/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum BodyEventsFeaturesEnum {
    COLOR = 'color',
    CLOTHES = 'clothes',
    PROTECTIVE_EQUIPMENT = 'protective_equipment',
    BAGS = 'bags',
    AGE_GENDER = 'age_gender',
    FALL = 'fall',
    HANDFACE = 'handface',
    HANDFACE4 = 'handface4',
}